import { find } from "lodash";
import { useWizardTemplates } from "./useWizardTemplates";

export function useWizardTemplate(templateId: string) {
  const { templates, loading, error } = useWizardTemplates();
  const template = find(templates, { id: templateId });
  return {
    template,
    loading,
    error: error && !!template,
  };
}
